import React from 'react';
import { Modal, Button, Tag, Row, Col } from 'antd';
import dayjs from 'dayjs';
import { Schedule } from '../types';
import ScheduleCard from './ScheduleCard';

interface ScheduleDetailModalProps {
  visible: boolean;
  onClose: () => void;
  selectedDate: dayjs.Dayjs;
  selectedSchedules: Schedule[];
  onEdit: (schedule: Schedule) => void;
  onDelete: (scheduleId: string) => void;
  deleting: string | null;
  submitting: boolean;
}

const ScheduleDetailModal: React.FC<ScheduleDetailModalProps> = ({
  visible,
  onClose,
  selectedDate,
  selectedSchedules,
  onEdit,
  onDelete,
  deleting,
  submitting,
}) => {
  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>📅</span>
          <span>Schedules for {selectedDate.format('MMMM D, YYYY')}</span>
          {selectedSchedules.length > 0 && (
            <Tag color="blue" style={{ marginLeft: 8 }}>
              {selectedSchedules.length} schedule
              {selectedSchedules.length > 1 ? 's' : ''}
            </Tag>
          )}
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
      width={800}
    >
      <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
        {selectedSchedules.length === 0 ? (
          <div
            style={{
              textAlign: 'center',
              padding: '40px 20px',
              color: '#999',
              background: '#fafafa',
              borderRadius: '6px',
              border: '1px dashed #d9d9d9',
            }}
          >
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>🗓️</div>
            <div
              style={{
                fontSize: '16px',
                fontWeight: 500,
                marginBottom: '8px',
              }}
            >
              No collection schedules
            </div>
            <div style={{ fontSize: '14px' }}>
              No schedules are configured for this date
            </div>
          </div>
        ) : (
          <div>
            <div
              style={{
                marginBottom: '16px',
                padding: '12px',
                background: '#f0f9ff',
                borderRadius: '6px',
                border: '1px solid #bae7ff',
              }}
            >
              <div
                style={{
                  fontSize: '14px',
                  color: '#1890ff',
                  fontWeight: 500,
                }}
              >
                Collection Day Details
              </div>
              <div
                style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}
              >
                The following schedules are active for{' '}
                {selectedDate.format('dddd, MMMM D, YYYY')}
              </div>
            </div>
            <Row gutter={[16, 16]}>
              {selectedSchedules.map((schedule) => (
                <Col key={schedule.id} xs={24} sm={24} md={24}>
                  <ScheduleCard
                    schedule={schedule}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    deleting={deleting}
                    submitting={submitting}
                  />
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ScheduleDetailModal;
